import { User, Device, Package } from "../models";
import { APIVersion, AuthenticatedFileRequest, AuthenticatedRequest, HTTPMethod, Session, BasicRequest } from "../requests/request";
import { DeviceData } from "..";

export interface Coupon {
    percent_off?: number
    duration: 'forever' | 'once'
    duration_in_months: number
    amount_off?: number
}

export class API {

    public static getPackages(): Promise<Package[]> {
        let apiRequest = new BasicRequest<Package>('/subscription_packages', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send(Package).then((response) => {
            return <Package[]>response.data;
        });

    }

    public static setDefaultCard(id: string): Promise<void> {
        let apiRequest = new AuthenticatedRequest<Package>('/credit-card/default', HTTPMethod.POST, APIVersion.v1_0, undefined, { id });

        return apiRequest.send().then((response) => {
            return response.data;
        });

    }

    public static createCreditCard(card: {
        token: string
    }): Promise<{
        id: string;
        brand: string,
        last4: string,
        name: string,
        exp: string,
    }> {
        let apiRequest = new AuthenticatedRequest('/credit-card', HTTPMethod.POST, APIVersion.v1_0, undefined, card);

        return apiRequest.send().then((response) => {
            return response.data;
        });

    }

    public static getCreditCard(): Promise<{
        id: string;
        brand: string,
        last4: string,
        name: string,
        exp: string,
    }> {
        let apiRequest = new AuthenticatedRequest<Package>('/credit-card/default', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return response.data;
        });

    }

    public static getAllCreditCards(): Promise<{
        id: string;
        brand: string,
        last4: string,
        name: string,
        exp: string,
    }[]> {
        let apiRequest = new AuthenticatedRequest<Package>('/credit-card/all', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return response.data;
        });

    }

    public static getCoupon(coupon: string): Promise<Coupon> {
        let apiRequest = new AuthenticatedRequest('/coupon/' + coupon, HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static subscribe(packag: Package, plan: string, coupon?: string): Promise<User> {
        let apiRequest = new AuthenticatedRequest<User>('/subscription/' + packag.id, HTTPMethod.POST, APIVersion.v1_0, undefined, { plan, coupon });

        return apiRequest.send(User).then((response) => {
            return response.data;
        });

    }

    public static upgrade(packag: Package, plan: string, coupon?: string): Promise<User> {
        let apiRequest = new AuthenticatedRequest<User>('/subscription/' + packag.id + '/upgrade', HTTPMethod.POST, APIVersion.v1_0, undefined, { plan, coupon });

        return apiRequest.send(User).then((response) => {
            return response.data;
        });

    }

    public static cancel(now: boolean): Promise<User> {
        let apiRequest = new AuthenticatedRequest<User>('/subscription/' + (now ? 'now' : 'nextRenewal'), HTTPMethod.DELETE, APIVersion.v1_0);

        return apiRequest.send(User).then((response) => {
            return response.data;
        });

    }

}


// WEBPACK FOOTER //
// ./src/api/endpoints/payments.ts